import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { EmrModalComponent, GetDistanceToTargetsRequest } from 'emr-ng-shared';
import { ShowDistanceComponent } from '../show-distance/show-distance.component';

@Component({
  selector: 'app-show-distance-popup',
  templateUrl: './show-distance-popup.component.html',
  styleUrls: ['./show-distance-popup.component.css'],
  standalone: true,
  imports: [EmrModalComponent, ShowDistanceComponent]
})
export class ShowDistancePopupComponent implements OnInit {

  constructor(
    public bsShowDistanceModalRef: BsModalRef
  ) { }

  distanceToTargetsRequest: GetDistanceToTargetsRequest;

  ngOnInit() {
  }

  onPopupCancel() {
    this.bsShowDistanceModalRef.hide();
  }
}


